import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import brand from "../brand";
import AdPlaceHolder from "../components/AdPlaceHolder";
import ResultImagePanel from "../components/ResultImagePanel";
import { downloadResultPdf, fetchResultImage, getTodayIsoDate, shareResult } from "../utils/resultApi";

const contentSections = [
  {
    title: "Sikkim state lotteries result today (सिक्किम राज्य लॉटरी परिणाम)",
    body: "Sikkim lottery result today. Click on the link above to Download and view Sikkim lottery result online. Sikkim today lottery result PDF online. Sikkim lottery result also updated here on this site.",
  },
  {
    title: "Nagaland state lottery result today (नागालैंड राज्य लॉटरी परिणाम)",
    body: "Nagaland lottery result today. Click on the link above to Download and view Nagaland state lotteries result online. Nagaland today lottery result pdf file online. You may check Nagaland state lottery morning 2025 here online. Stay connected with us to check daily Nagaland state lottery result of the day. Check all Sambad Lottery Result right over here.",
  },
  {
    title: "West bengal state lottery (पश्चिम बंगाल राज्य लॉटरी परिणाम)",
    body: "Check west Bengal state lottery today result 6:00 PM online. West bengal old as well as today lottery draw result will be updated here on this page. Stay connected with us to check and download west bengal lottery draw result online. West Bengal lottery is one of the most and popular lottery around the globe. Keep visiting our site to check west bengal lottery draw result of the day. We also update you here with the new bumper prizes.",
  },
  {
    title: "Mizoram state lottery result today",
    body: "Mizoram lottery result today. Click on the link above to Download and view Mizoram lottery result online. Mizoram today lottery result pdf file online. Get PDF file Today's result. Click on the given tab in the menu bar to download Sambad lottery today result, yesterday result as well as old results. Mizoram Lottery Result will be updated here as per schedule.",
  },
  {
    title: "Mizoram Lottery Result",
    body: "Mizoram state lottery result will also be updated here on this page. Stay connected with us to get download Mizoram lottery result of the day. Mizoram lottery result provided you in the PDF format as well as you can view it on this page.",
  },
  {
    title: "Sikkim State Lottery Result",
    body: "You can check your Sikkim lottery result. Just click on the above link to get your sikkim state today result. Sikkim lottery result updated on the daily basis. Even check all Dear Lottery Results here.",
  },
  {
    title: "Nagaland State Lottery Result",
    body: "You can also get download Nagaland state lottery result here as well. Nagaland lottery result will be updated on the daily basis. Stay with us to view and download your all lotteries results.",
  },
  {
    title: "Lottery (লটারি সংবাদ) Mobile App",
    body: "Those who are regular lottery ticket buyers, They can just get download and install app in their mobile phones. Get read Sambad Newspaper with us.",
  },
  {
    title: "Draw Result",
    body: "Today all of the result has been updated here on this page. All result has been updated here on this one single page for the day May 12 2026. All of you may check result online. You may check old results, bumper results, daily results and Sambad news. Keep checking your lucky number on the daily basis with us.",
  },
];

const scheduleRows = [
  ["1:00 PM", "Shillong Afternoon Result", "Daily"],
  // ["6:00 PM", "Evening State Updates", "Information"],
  ["8:00 PM", "Shillong Night Result", "Daily"],
];

const Home = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState("");
  const navigate = useNavigate();
  const todayText = new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date());

  useEffect(() => {
    let active = true;

    const loadResults = async () => {
      try {
        const entries = await Promise.all(
          brand.drawTimes.map(async (draw) => [draw.key, await fetchResultImage(draw.key)])
        );
        if (active) {
          setResults(Object.fromEntries(entries));
        }
      } catch (error) {
        if (active) {
          setNotice("Live results are temporarily unavailable. Please try again shortly.");
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    loadResults();
    const interval = window.setInterval(loadResults, 60000);
    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, []);

  const handleDownload = async (draw) => {
    try {
      await downloadResultPdf(results[draw.key], draw.key);
    } catch (error) {
      setNotice(error.message);
    }
  };

  const handleShare = async (draw) => {
    try {
      const result = await shareResult({
        title: `${brand.name} ${draw.label} Result`,
        text: `${brand.name} ${draw.label} result for ${getTodayIsoDate()}`,
      });
      setNotice(result === "copied" ? "Result link copied." : "Share panel opened.");
    } catch (error) {
      setNotice("Sharing is not available on this device.");
    }
  };

  return (
    <main className="site-home govt-home">
      <section className="govt-hero">
        <span className="govt-kicker">Public result information portal</span>
        <h1>{brand.name} Today</h1>
        <p>
          {brand.name} result {todayText}. Check daily 1:00 PM and 8:00 PM
          result updates, old results, PDF download, and draw information.
        </p>
        <div className="govt-actions" aria-label="Draw result links">
          <button type="button" onClick={() => navigate("/onepmresult")}>
            1:00 PM
          </button>
          {/* <a href="#sixpm-info">6:00 PM</a>/ */}
          <button type="button" onClick={() => navigate("/eightpmresult")}>
            8:00 PM
          </button>
          <button type="button" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </div>
      </section>

      {notice && <div className="toast-line">{notice}</div>}

      <AdPlaceHolder />

      <section className="official-notice">
        <strong>Important Notice</strong>
        <span>
          This website provides result information for reference. Please verify
          prize claims and ticket details with the official published notice.
        </span>
      </section>

      <section className="result-board">
        <div className="board-heading">
          <h2>{todayText}</h2>
          <p>Latest published draw result</p>
        </div>
        <div className="draw-grid official-draw-grid">
          {brand.drawTimes.map((draw) => (
            <ResultImagePanel
              key={draw.key}
              title={`${brand.name} Result`}
              draw={draw}
              imageUrl={results[draw.key]}
              loading={loading}
              message={`${draw.label} result is coming shortly`}
              onDownload={() => handleDownload(draw)}
              onShare={() => handleShare(draw)}
            />
          ))}
        </div>
      </section>

      <section className="sambad-copy">
        <h2>{brand.name} Result</h2>
        <p>
          {brand.name} today result {todayText}. Lottery draw information is
          updated here for daily visitors. You may check your lottery result
          right over here. <Link to="/onepmresult">{brand.name}</Link> 1:00 PM
          and 8:00 PM result updates are available from the menu bar. Stay tuned
          to check daily lottery result, old result, bumper result, and result
          archive updates.
        </p>
      </section>

      <section className="schedule-section" id="sixpm-info">
        <h2>Draw Schedule</h2>
        <table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Draw Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {scheduleRows.map(([time, name, status]) => (
              <tr key={time}>
                <td>{time}</td>
                <td>{name}</td>
                <td>{status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="seo-content">
        {contentSections.map((section) => (
          <article key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </article>
        ))}

        <article>
          <h2>Lottery Sambad Result Today</h2>
          <p>
            Lottery Sambad is very famous and popular lottery of India. Everyday
            you can get three times lottery draw results here on this page. The
            result schedule is given you below.
          </p>
          <ul className="today-links">
            <li>
              <Link to="/onepmresult">Today 1PM</Link>
            </li>
            {/* <li>
              <a href="#sixpm-info">Today 6PM</a>
            </li> */}
            <li>
              <Link to="/eightpmresult">Today 8PM</Link>
            </li>
          </ul>
          <p>
            Sambad lottery is also popular in the west bengal and Kolkata. You
            can get Sambad lottery chart.
          </p>
        </article>

        <article>
          <p>
            For the more information you are seeking as regards of the lottery
            you can contact us through submitting us contact form. Contact form
            has been provided to you. Recommend us more technical improvements
            regarding website.
          </p>
        </article>

        <article className="faq-block">
          <h2>Is Nagaland State lottery real?</h2>
          <p>
            Yes its 100% real. Nagaland state lottery owned and regulate by the
            Nagaland and established in 1972. It run, regulated, supervised and
            financed by the Nagaland state.
          </p>
          <h2>How much time will it take to get money after winning the lottery?</h2>
          <p>
            It will take three days after submission of all required documents
            alongwith original winning ticket.
          </p>
        </article>
      </section>
    </main>
  );
};

export default Home;
